import { getErrorMessage } from "../utils/commonUtils";
import { toast } from "react-toastify";
import {
  useGetLotSearchItemsMutation,
  useGetOrderingProductInventoryReportMutation,
  useGetOrderingProductReportMutation,
  useGetQtyOnHandInventoryReportMutation,
  useGetUserslistMutation,
  useInventoryAdjustmentDetailExportMutation,
  useInventoryExpireExportMutation,
  useInventoryRecalledItemExportMutation,
  useInventoryReceiveDetailExportMutation,
  useInventoryReconciliationExportMutation,
  useInventoryStausExportMutation,
  useInventoryTranferDetailExportMutation,
  useInventoryUsageDetailExportMutation,
  useLotSearchItemExportMutation,
  useLotSearchPatientsExportMutation,
  useMedicationListExportMutation,
  useProviderListExportMutation,
  useTrReportsDDMutation,
  useTrReportsMutation,
  useUserListExportMutation,
  useOrderingProductReportExportMutation,
  useOrderingProductInventoryReportExportMutation,
  useGetRxHistoryMutation,
  useRxHistoryReportExportMutation,
  useMedicationUOMExportMutation,
  useGetCostHistoryMutation,
  useCostHistoryReportExportMutation,
  useExpiringInventoryReportMutation,
  useEmailExpiredInventoryReportMutation,
  useCycleCountReportMutation,
  useExportCycleCountReportAsTallyMutation,
  useExportCycleCountReportMutation,
  useGetCapitalEquipmentReportMutation,
  useExportCapitalEquipmentReportMutation,
  useLocationListExportMutation,
} from "../redux/reports/reportsApiSlice";

export default function useReports() {
  const [getUserslist, { isLoading: getUserslistLoading }] =
    useGetUserslistMutation();
  const [trReportsDD, { isLoading: trReportsDDLoading }] =
    useTrReportsDDMutation();
  const [trReports, { isLoading: trReportsLoading }] = useTrReportsMutation();
  const [inventoryStausExport, { isLoading: inventoryStausExportLoading }] = useInventoryStausExportMutation();
  const [getLotSearchItems, { isLoading: getLotSearchItemsLoading }] = useGetLotSearchItemsMutation();
  const [lotSearchItemExport, { isLoading: lotSearchItemExportLoading }] = useLotSearchItemExportMutation();
  const [lotSearchPatientsExport, { isLoading: lotSearchPatientsExportLoading }] = useLotSearchPatientsExportMutation();
  const [inventoryExpireExport, { isLoading: inventoryExpireExportLoading }] = useInventoryExpireExportMutation();
  const [inventoryReceiveDetailExport, { isLoading: inventoryRecevieDetailExportLoading }] = useInventoryReceiveDetailExportMutation();
  const [inventoryUsageDetailExport, { isLoading: inventoryUsageDetailExportLoading }] = useInventoryUsageDetailExportMutation();
  const [inventoryTranferDetailExport, { isLoading: inventoryTranferDetailExportLoading }] = useInventoryTranferDetailExportMutation();
  const [inventoryAdjustmentDetailExport, { isLoading: inventoryAdjustmentDetailExportLoading }] = useInventoryAdjustmentDetailExportMutation();
  const [inventoryReconciliationExport, { isLoading: inventoryReconciliationExportLoading }] = useInventoryReconciliationExportMutation();
  const [inventoryRecalledItemExport, { isLoading: inventoryRecalledItemExportLoading }] = useInventoryRecalledItemExportMutation();
  const [providerListExport, { isLoading: providerListExportLoading }] = useProviderListExportMutation();
  const [userListExport, { isLoading: userListExportLoading }] = useUserListExportMutation();
  const [medicationListExport, { isLoading: medicationListExportLoading }] = useMedicationListExportMutation();
  const [medicationUOMExport, { isLoading: medicationUOMExportLoading }] = useMedicationUOMExportMutation();
  const [getOrderingProductReport, { isLoading: getOrderingProductReportLoading }] = useGetOrderingProductReportMutation();
  const [getOrderingProductInventoryReport, { isLoading: getOrderingProductInventoryReportLoading }] = useGetOrderingProductInventoryReportMutation();
  const [getQtyOnHandInventoryReport, { isLoading: getQtyOnHandInventoryReportLoading }] = useGetQtyOnHandInventoryReportMutation();
  const [orderingProductReportExport, { isLoading: orderingProductReportExportLoading }] = useOrderingProductReportExportMutation();
  const [orderingProductInventoryReportExport, { isLoading: orderingProductInventoryReportExportLoading }] = useOrderingProductInventoryReportExportMutation();
  const [getRxHistory, { isLoading: getRxHistoryLoading }] = useGetRxHistoryMutation();
  const [rxHistoryReportExport, { isLoading: rxHistoryReportExportLoading }] = useRxHistoryReportExportMutation();
  const [getCostHistory, { isLoading: getCostHistoryLoading }] = useGetCostHistoryMutation();
  const [costHistoryReportExport, { isLoading: costHistoryReportExportLoading }] = useCostHistoryReportExportMutation();
  const [expiringInventoryReport, { isLoading: expiringInventoryReportLoading }] = useExpiringInventoryReportMutation();
  const [emailExpiredInventoryReport, { isLoading: emailExpiredInventoryReportLoading }] = useEmailExpiredInventoryReportMutation();
  const [cycleCountReport, { isLoading: cycleCountReportLoading }] = useCycleCountReportMutation();
  const [exportCycleCountReport, { isLoading: exportCycleCountReportLoading }] = useExportCycleCountReportMutation();
  const [exportCycleCountReportAsTally, { isLoading: exportCycleCountReportAsTallyLoading }] = useExportCycleCountReportAsTallyMutation();
  const [getCapitalEquipmentReport, { isLoading: getCapitalEquipmentReportLoading }] = useGetCapitalEquipmentReportMutation();
  const [exportCapitalEquipmentReport, { isLoading: exportCapitalEquipmentReportLoading }] = useExportCapitalEquipmentReportMutation();
  const [locationListExport, { isLoading: locationListExportLoading }] = useLocationListExportMutation();

  const getUserslistAPI = async (data: any) => {
    try {
      const response: any = await getUserslist(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const trReportsDDAPI = async () => {
    try {
      const response: any = await trReportsDD({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const trReportsAPI = async (data: any) => {
    try {
      const response: any = await trReports(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const inventoryStausExportAPI = async (data: any) => {
    try {
      const response: any = await inventoryStausExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const inventoryExpireExportAPI = async (data: any) => {
    try {
      const response: any = await inventoryExpireExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const inventoryReceiveExportAPI = async (data: any) => {
    try {
      const response: any = await inventoryReceiveDetailExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const inventoryUsageDetailExportAPI = async (data: any) => {
    try {
      const response: any = await inventoryUsageDetailExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const inventoryTranferDetailExportAPI = async (data: any) => {
    try {
      const response: any = await inventoryTranferDetailExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const inventoryAdjustmentDetailExportAPI = async (data: any) => {
    try {
      const response: any = await inventoryAdjustmentDetailExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const inventoryReconciliationExportAPI = async (data: any) => {
    try {
      const response: any = await inventoryReconciliationExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const inventoryRecallItemExportAPI = async (data: any) => {
    try {
      const response: any = await inventoryRecalledItemExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const providerListExportAPI = async (data: any) => {
    try {
      const response: any = await providerListExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const userListExportAPI = async (data: any) => {
    try {
      const response: any = await userListExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const medicationListExportAPI = async (data: any) => {
    try {
      const response: any = await medicationListExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const medicationUOMExportAPI = async (data: any) => {
    try {
      const response: any = await medicationUOMExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getLotSearchItemsAPI = async (data: any) => {
    try {
      const response: any = await getLotSearchItems(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const lotSearchItemExportAPI = async (data: any) => {
    try {
      const response: any = await lotSearchItemExport(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const lotSearchPatientsExportAPI = async (data: any) => {
    try {
      const response: any = await lotSearchPatientsExport(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getOrderingProductReportAPI = async (data: any) => {
    try {
      const response: any = await getOrderingProductReport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getOrderingProductInventoryAPI = async (data: any) => {
    try {
      const response: any = await getOrderingProductInventoryReport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  }
  const getQtyOnHandInventoryAPI = async (data: any) => {
    try {
      const response: any = await getQtyOnHandInventoryReport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  }
  const orderingProductReportExportAPI = async (data: any) => {
    try {
      const response: any = await orderingProductReportExport(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const orderingProductInventoryReportExportAPI = async (data: any) => {
    try {
      const response: any = await orderingProductInventoryReportExport(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getRxHistoryAPI = async (data: any) => {
    try {
      const response: any = await getRxHistory(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const rxHistoryReportExportAPI = async (data: any) => {
    try {
      const response: any = await rxHistoryReportExport(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCostHistoryAPI = async (data: any) => {
    try {
      const response: any = await getCostHistory(data).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const costHistoryReportExportAPI = async (data: any) => {
    try {
      const response: any = await costHistoryReportExport(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const expiringInventoryReportAPI = async (data: any) => {
    try {
      const response: any = await expiringInventoryReport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const emailExpiredInventoryReportAPI = async (data: any) => {
    try {
      const response: any = await emailExpiredInventoryReport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCycleCountReportAPI = async (data: any) => {
    try {
      const response: any = await cycleCountReport(data).unwrap();
      return response.result || response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const exportCycleCountReportAPI = async (data: any) => {
    try {
      const response: any = await exportCycleCountReport(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      if (typeof err?.data === 'string') {
        toast.error(err.data);
        throw new Error(err.data);
      }
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const exportCycleCountReportAsTallyAPI = async (data: any) => {
    try {
      const response: any = await exportCycleCountReportAsTally(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      if (typeof err?.data === 'string') {
        toast.error(err.data);
        throw new Error(err.data);
      }
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCapitalEquipmentReportAPI = async () => {
    try {
      const response: any = await getCapitalEquipmentReport({}).unwrap();
      return response.result || response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const locationListExportAPI = async (data: any) => {
    try {
      const response: any = await locationListExport(data).unwrap();
      return response;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const exportCapitalEquipmentReportAPI = async (data: any) => {
    try {
      const response: any = await exportCapitalEquipmentReport(data).unwrap();
      toast.success("Success!. File downloaded successfully");
      return response;
    } catch (err: any) {
      if (typeof err?.data === 'string') {
        toast.error(err.data);
        throw new Error(err.data);
      }
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };

  return {
    getUserslistAPI,
    getUserslistLoading,
    trReportsDDAPI,
    trReportsDDLoading,
    trReportsAPI,
    trReportsLoading,
    inventoryStausExportAPI,
    inventoryStausExportLoading,
    getLotSearchItemsAPI,
    getLotSearchItemsLoading,
    lotSearchItemExportAPI,
    lotSearchItemExportLoading,
    lotSearchPatientsExportAPI,
    lotSearchPatientsExportLoading,
    inventoryExpireExportAPI,
    inventoryExpireExportLoading,
    inventoryReceiveExportAPI,
    inventoryRecevieDetailExportLoading,
    inventoryUsageDetailExportAPI,
    inventoryUsageDetailExportLoading,
    inventoryTranferDetailExportAPI,
    inventoryTranferDetailExportLoading,
    inventoryAdjustmentDetailExportAPI,
    inventoryAdjustmentDetailExportLoading,
    inventoryReconciliationExportAPI,
    inventoryReconciliationExportLoading,
    inventoryRecallItemExportAPI,
    inventoryRecalledItemExportLoading,
    providerListExportAPI,
    providerListExportLoading,
    userListExportAPI,
    userListExportLoading,
    medicationListExportAPI,
    medicationListExportLoading,
    medicationUOMExportAPI,
    medicationUOMExportLoading,
    getOrderingProductReportAPI,
    getOrderingProductReportLoading,
    getOrderingProductInventoryAPI,
    getOrderingProductInventoryReportLoading,
    getQtyOnHandInventoryAPI,
    getQtyOnHandInventoryReportLoading,
    orderingProductReportExportAPI,
    orderingProductReportExportLoading,
    orderingProductInventoryReportExportAPI,
    orderingProductInventoryReportExportLoading,
    getRxHistoryAPI,
    getRxHistoryLoading,
    rxHistoryReportExportAPI,
    rxHistoryReportExportLoading,
    getCostHistoryAPI,
    getCostHistoryLoading,
    costHistoryReportExportAPI,
    costHistoryReportExportLoading,
    expiringInventoryReportAPI,
    expiringInventoryReportLoading,
    emailExpiredInventoryReportAPI,
    emailExpiredInventoryReportLoading,
    getCycleCountReportAPI,
    cycleCountReportLoading,
    exportCycleCountReportAPI,
    exportCycleCountReportLoading,
    exportCycleCountReportAsTallyAPI,
    exportCycleCountReportAsTallyLoading,
    getCapitalEquipmentReportAPI,
    getCapitalEquipmentReportLoading,
    exportCapitalEquipmentReportAPI,
    exportCapitalEquipmentReportLoading,
    locationListExportAPI,
    locationListExportLoading,
  };
}
